module.exports = __webpack_public_path__ + "static/media/img33.1c9289f2.jpg";